module.exports = __webpack_public_path__ + "static/images/components/WGCWXConfirmation/images/alert_light.fdac27de.png";


//////////////////
// WEBPACK FOOTER
// ./components/WGCWXConfirmation/images/alert_light.png
// module id = 2730
// module chunks = 11